<button on:click>
  <slot />
</button>

<style lang="postcss">
  button {
    @apply px-5 py-2 text-primary-datadocs-blue border-[1.5px] border-solid border-primary-datadocs-blue rounded;
    @apply bg-primary-datadocs-blue bg-opacity-0;
  }

  button:active,
  button:hover {
    @apply bg-primary-datadocs-blue bg-opacity-10;
  }
</style>
